import "./Login.css";
import React from "react";
import { Button } from "react-bootstrap";

const Login = (props) => {
  return (
    <section className="login-panel">
      <div className="login-container">
        <label for="username">Username</label>
        <input
          onChange={(e) => {
            props.setUsername(e.target.value);
          }}
          id="username"
          type="text"
        ></input>
        <label for="password">Password</label>
        <input
          onChange={(e) => {
            props.setPassword(e.target.value);
          }}
          id="password"
          type="password"
        ></input>
        {props.User.admin}
        <Button
          onClick={() => {
            props.login();
          }}
        >
          LOGIN
        </Button>
      </div>
    </section>
  );
};

export default Login;
